// extracted by mini-css-extract-plugin
export default {"bottomBar":"oTfEDk9BPEZhbgCBlUUR","closeIcon":"bQuBgehQIHkOjc26HRlb"};